import React, { useState, useEffect } from 'react';

const projectsData = [
    {
    id: 1,
    title: "Night Sky",
    description: "Proof-of-concept using data from the Yale Bright Star Catalog to create a particle system using WebGL. No images or textures were used - the whole simulation was made using raw astronomy data and shaders. Click and drag to explore the night sky. This is a current work in progress; I am planning to add an information box displaying the names and mythologies of the various constellations.",
    imageUrl: "./project_photos/planetarium.jpg",
    projectUrl: "https://planetarium-sky.vercel.app/"
  },
  {
    id: 2,
    title: "Kait's room",
    description: "I wanted to lean in to the inherent architectural-ness of the web, to make a site with nooks and crannies that could surprise you a bit if you poked around. While doing this project I learned a lot about some classic graphics topics and web packages (OpenGL shaders, React Three Fiber, Blender, UV unwrapping and baking), as well as maintaining accessibility when working with 3D websites. It was a fruitful challenge to make it both keyboard friendly and screen-reader accessible.",
    imageUrl: "./project_photos/kait-room.jpg",
    projectUrl: "https://kait-room.vercel.app"
  },
    {
    id: 3,
    title: "Lenticular Print",
    description: "This is a proof of concept I made using a custom GLSL shaders to mimic the behavior of a lenticular print (like a 3D postcard). I learned how to use the Sampler2DArray data type to stack and sample different textures dynamically (in this case, based on the angle between the viewer and the print). Click and drag to see the effect.",
    imageUrl: "./project_photos/lenticular_web.png",
    projectUrl: "https://lenticular.vercel.app"
  },
  {
    id: 4,
    title: "Half Life",
    description: "Sound art video exploring notions of transformation and decay, using sounds both found and generated using an analog synthesizer.",
    imageUrl: "./project_photos/half_life.jpg",
    projectUrl: "https://vimeo.com/215273146?share=copy"
  },
  {
    id: 5,
    title: "Tidepool",
    description: "Tidepool is an app I built for a company I started at the Jersey Shore in 2024. The purpose of the company is to make vacationing easier by offering bike, kayak, and surfboard rentals in addition to being a centralized information hub.",
    imageUrl: "./project_photos/foam.jpg",
    projectUrl: "https://apps.apple.com/us/app/tidepool/id6667095373"
  }
];

const AnimatedProjectCard = ({ project, index, skipAnimation }) => {
  const [visible, setVisible] = useState(skipAnimation);

  useEffect(() => {
    if (skipAnimation) return;
    const timer = setTimeout(() => {
      setVisible(true);
    }, 200 * index);

    return () => clearTimeout(timer);
  }, [index, skipAnimation]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1000);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  
  return (
    <div 
      className="project-card" 
      style={{
        opacity: visible ? 1 : 0,
        transform: `translateY(${visible ? 0 : '30px'})`,
        transition: 'opacity 2.0s ease, transform 2.0s ease',
      }}
    >
      <div className="card-content">
        <div className="image-container">
          <a href={project.projectUrl} target="_blank" rel="noopener noreferrer">
            <img  style = {{
             height: isMobile ? '200px' : '400px'
              }} 
              src={project.imageUrl} alt={project.title} />
          </a>
        </div>
        <div className="text-container">
          <h2>{project.title}</h2>
          <p style={{
            fontSize: isMobile ? '14px' : '16px'
            }}>{project.description}</p>
        </div>
      </div>
    </div>
  );
};

export default function Projects() {
  const skipAnimation = sessionStorage.getItem('projectsAnimated') === 'true';

  useEffect(() => {
    sessionStorage.setItem('projectsAnimated', 'true');
  }, []);

  return (
    <>
      <div className="projects-container">
        <div className="projects-grid">
          {projectsData.map((project, index) => (
            <AnimatedProjectCard
              key={project.id}
              project={project}
              index={index}
              skipAnimation={skipAnimation}
            />
          ))}
        </div>
      </div>

      <style jsx="true">{`
        .projects-container {
          width: 86.5%;
          margin: 0 auto;
          padding: 20px;
          height: 100%;
          margin-top: 4%;
          // border-style: solid;
          // border-width: 1px;
          // border-color: black;
        }
        
        .projects-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 30px;
          width: 100%;
        }
        
        .project-card {
          border-radius: 5px;
          overflow: hidden;
          width: 95%;
          // border-style: solid;
          // border-width: 1px;
          // border-color: black;
        }
        
        .card-content {
          display: flex;
          flex-direction: column;
        }
        
        .image-container {
          flex: 0 0 auto;
          overflow: hidden;
        }
        
        .image-container img {
          width: 100%;
          object-fit: cover;
          transition: transform 0.5s ease-in-out;
          // filter: grayscale(100%);
          // transition: filter 0.5s ease-in-out;
        }
        
        .image-container img:hover {
          transform: scale(1.05);
          // filter: grayscale(0%);
        }
        
        .text-container {
          flex: 0 0 auto;
          padding: 20px;
        }
        
        .text-container h2 {
          margin-top: 0;
          color: #333;
          font-size: 20px;
        }
        
        .text-container p {
          color: #666;
          margin-bottom: 18px;
          font-size: 16px;
          line-height: 1.6;
        }
        
        @media (max-width: 768px) {
          .projects-grid {
            grid-template-columns: 1fr;
            margin-bottom: 200px;
          }
          
          .card-content {
            flex-direction: column;
          }
          
          .image-container, .text-container {
            flex: 0 0 100%;
          }
          
          .image-container {
            max-height: 500px;
          }
            
        }
      `}</style>
    </>
  );
}